import ws from '../utils/ws';

/* Actions */

export const venueWebhookPaginatedList = (pageNumber, pageSize) => dispatch =>
  dispatch({
    type: VENUE_WEBHOOKS_PAGINATED_LIST,
    payload: ws.get(`/venue_webhooks/page/${pageNumber}/rows/${pageSize}`)
  });

export const venueWebhookValueUpdate = values => dispatch =>
  dispatch({
    type: CREATE_VENUE_WEBHOOK_VALUE_UPDATE,
    payload: values
  });

export const venueWebhookValueReset = () => dispatch =>
  dispatch({
    type: CREATE_VENUE_WEBHOOK_VALUE_RESET
  });

export const saveVenueWebhook = webhook => dispatch =>
  dispatch({
    type: SAVE_VENUE_WEBHOOK,
    payload: ws.post('/venue_webhooks/', webhook)
  });

export const deleteVenueWebhook = webhook => dispatch =>
  dispatch({
    type: DELETE_VENUE_WEBHOOK,
    payload: ws.post(`/venue_webhooks/${webhook.id}/delete`)
  });

export const editVenueWebhook = id => dispatch =>
  dispatch({
    type: EDIT_VENUE_WEBHOOK,
    payload: ws.get(`/venue_webhooks/${id}`)
  });

/* Constants */

export const VENUE_WEBHOOKS_PAGINATED_LIST = 'VENUE_WEBHOOKS_PAGINATED_LIST';
export const VENUE_WEBHOOKS_PAGINATED_LIST_PENDING =
  'VENUE_WEBHOOKS_PAGINATED_LIST_PENDING';
export const VENUE_WEBHOOKS_PAGINATED_LIST_FULFILLED =
  'VENUE_WEBHOOKS_PAGINATED_LIST_FULFILLED';

export const CREATE_VENUE_WEBHOOK_VALUE_UPDATE =
  'CREATE_VENUE_WEBHOOK_VALUE_UPDATE';
export const CREATE_VENUE_WEBHOOK_VALUE_RESET =
  'CREATE_VENUE_WEBHOOK_VALUE_RESET';

export const SAVE_VENUE_WEBHOOK = 'SAVE_VENUE_WEBHOOK';
export const SAVE_VENUE_WEBHOOK_PENDING = 'SAVE_VENUE_WEBHOOK_PENDING';
export const SAVE_VENUE_WEBHOOK_FULFILLED = 'SAVE_VENUE_WEBHOOK_FULFILLED';

export const DELETE_VENUE_WEBHOOK = 'DELETE_VENUE_WEBHOOK';
export const DELETE_VENUE_WEBHOOK_FULFILLED = 'DELETE_VENUE_WEBHOOK_FULFILLED';

export const EDIT_VENUE_WEBHOOK = 'EDIT_VENUE_WEBHOOK';
export const EDIT_VENUE_WEBHOOK_FULFILLED = 'EDIT_VENUE_WEBHOOK_FULFILLED';
